import type { DOMConversionMap } from "lexical";
import type { JSX } from "react";
import { DynamicContentToolbar } from "./dynamic-content-toolbar";
import { DynamicContentToolbarNode } from "./dynamic-content-toolbar-node";
import { convertDynamicContentToolbarElement, isDynamicContentToolbarElement } from "./export";
import type { SerializedDynamicToolbarNode } from "./types";

export class DynamicContentToolbarNodeMui extends DynamicContentToolbarNode {
  decorate(): JSX.Element {
    return (
      <DynamicContentToolbar
        segmentId={this.getSegmentId()}
        open={this.getOpen()}
        parentKey={this.getParentDynamicContentNodeKey()}
        error={this.getError()}
      />
    );
  }

  static importJSON(serializedNode: SerializedDynamicToolbarNode): DynamicContentToolbarNodeMui {
    return super.importJSON(serializedNode);
  }

  exportJSON(): SerializedDynamicToolbarNode {
    return super.exportJSON();
  }

  static clone(node: DynamicContentToolbarNodeMui): DynamicContentToolbarNodeMui {
    return super.clone(node);
  }

  static getType(): string {
    return super.getType();
  }

  static importDOM(): DOMConversionMap | null {
    return {
      div: (node: HTMLElement) => {
        if (!isDynamicContentToolbarElement(node)) return null;

        return {
          conversion: (n) => convertDynamicContentToolbarElement(n, DynamicContentToolbarNodeMui),
          priority: 0,
        };
      },
    };
  }
}
